import { useCallback } from 'react';
import { NFTMarketplaceListing } from '@app/types/nftMarketplace';

export const useHandleUsdPriceReady = (
  listing: NFTMarketplaceListing,
  floorPrices: Record<string, number>,
  updateFloorPrices: (address: string, price: number) => void
) => {
  return useCallback(
    (val: number) => {
      const key = `${listing.nftContractAddress.toLowerCase()}`;

      if (!floorPrices[key] || val < floorPrices[key]) {
        console.log('updating');
        updateFloorPrices(key, val);
      }
    },
    [listing.nftContractAddress, floorPrices, updateFloorPrices]
  );
};
